import React from "react";

function SindhCom() {
  return (
    <div className="py-5">
      <div className="row row-cols-1 row-cols-md-2">
        <div className="col">
          <h2 className="text-h-m-orange">Sindh</h2>
          <br />
          <br />
          <h2 className="text-h-black">
            Securitising Movement, Migration, and Difference
          </h2>
          <br />
          <br />
          <br />
          <br />
          <p>
            In Sindh, paramilitary clean-up operations in its largest city,
            Karachi, and the interior have seen ethnic violence clash with an
            urban police state. As they complete their sentences, prisoners find
            themselves moving through different incarceration facilities
            to-and-fro: within the city, across the interior, and the detention
            system. The use of varying jail locations overlays the use of their
            individual spaces for the segregation of prisoners by ethnic
            identity and this becomes a spatial map for the securitisation of
            Sindh itself.
          </p>
        </div>
        <div className="col">
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/sindh-map.png")}
            alt="sindh-map"
          />
        </div>
      </div>
    </div>
  );
}

export default SindhCom;
